import {denormFn, normFn} from '../normalizerSupport';
import type * as Types from './types';

export const normalize = normFn<Types.CustomRunNamesObjSchema>(
  'run-names',
  whole => whole
);

export const denormalize = denormFn<Types.CustomRunNamesObjSchema>(
  part => part
);
